import React from 'react'

import { TableCell, Tooltip } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Contact = ({ row }) => {
  const contact = row?.loads?.[0]?.src_contact
  return (
    <TableCell padding='none' sx={{ maxWidth: 150 }}>
      <Tooltip title={contact} placement='left'>
        <TextCell fontSize={13} value={contact} noWrap width='98%' />
      </Tooltip>
    </TableCell>
  )
}

export default React.memo(Contact)
